import { makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { IconButton, InputAdornment } from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import {
    DatePicker,

    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

export default function QualityChecksFilter(props) {

    const classes = useStyles();

    const [fromDate, setFromDate] = useState(props.firstdate)
    const [tillDate, setTillDate] = useState(props.lastdate)
    const [checked, setChecked] = useState([0]); 

    const { t } = useTranslation();
    
    function handleFromDateChange(date) {
        setFromDate(date);
        props.updatedates(date,tillDate)
    }

    function handleTillDateChange(date) {
        setTillDate(date)
        props.updatedates(fromDate,date)
    }

    const handleToggle = (value) => () => { 
        props.updateoperators(value)       
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    return (
        <React.Fragment>
            <div className={classes.filterHeader}>
                <img className={classes.filter} alt="filter" src={process.env.PUBLIC_URL + '/img/filter.svg'}></img>
                <div className={classes.filterTitle}>Filter</div>
            </div>
            <div className={classes.date}>
                {t("Date")}
                </div>
            <div className={classes.fromtill}>
            {t("From")}
                </div>
            <div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker className={classes.datePicker}
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        format="dd-MM-yyyy"
                        onChange={date => handleFromDateChange(date)}
                        size='small'
                        value={fromDate}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment className={classes.inputAdornment} position="end">
                                    <IconButton className={classes.iconButton}>
                                        <img className={classes.calendar} alt="calendar" src={process.env.PUBLIC_URL + '/img/calendar.svg'}></img>
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </MuiPickersUtilsProvider>
            </div>

            <div className={classes.fromtill}>
            {t("Till")}
            </div>
            <div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker className={classes.datePicker}
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        format="dd-MM-yyyy"
                        onChange={date => handleTillDateChange(date)}
                        size='small'
                        value={tillDate}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment className={classes.inputAdornment} position="end">
                                    <IconButton className={classes.iconButton}>
                                        <img className={classes.calendar} alt="calendar" src={process.env.PUBLIC_URL + '/img/calendar.svg'}></img>
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </MuiPickersUtilsProvider>
            </div>

            <div className={classes.operator}>Operator</div>

            <div>

                <List className={classes.operatorList}>
                    {props.operators.map((operator) => {
                        const labelId = `checkbox-list-label-${operator}`;

                        return (
                            <ListItem className={classes.listItem} key={operator.id} role={undefined} dense button onClick={handleToggle(operator)}>
                                <ListItemIcon className={classes.checkBoxIcon}>
                                    <Checkbox
                                        className={classes.checkBox}
                                        disableRipple
                                        color="default"
                                        checked={checked.indexOf(operator) !== -1}
                                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                        icon={<span className={classes.icon} />}
                                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                                        // {...props}
                                    />
                                </ListItemIcon>
                                <ListItemText className={classes.operatorName} id={labelId} primary={operator.name} />
                            </ListItem>
                        );
                    })}
                </List>
            </div>
        </React.Fragment>




    )
}

const useStyles = makeStyles({

    filterTitle: {
        color: '#020100',
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        float: 'left'
    },
    filter: {
        float: 'left',
        marginRight: '5px'
    },
    datePicker: {
        borderRadius: "6px",
        backgroundColor: "white",
        "& input": {
            fontSize: "14px !important",
            fontFamily: "Lato, sans-serif !important",
        },
        marginBottom: '10px',
        marginLeft: "20px",
        width: "90%"

    },
    iconButton: {
        padding: "0px !important"
    },
    filterHeader: {
        display: 'block',
        width: "100%",
        height: "40px",
        marginLeft: "20px"
    },
    date: {
        display: 'block',
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        marginBottom: "10px",
        marginLeft: "20px"
    },
    fromtill: {
        display: 'block',
        color: '#020100',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        marginLeft: "20px"
    },
    operator: {
        display: 'block',
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        marginTop: "10px",
        marginLeft: "20px"
    },
    operatorName: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        marginLeft: "10px"
    },
    checkBoxIcon: {
        minWidth: "0px",
        width: "20px",
        height: "20px",
        margin: "0px"
    },
    listItem: {
        paddingLeft: "0px",
        marginLeft: "10px"
    },
    operatorList: {
        marginTop: "0px"
    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: 3,
        width: 14,
        height: 14,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 14,
            height: 14,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
    },
});